import { SET_ENTITY } from "@/store/mutation-types";

const module = "FR_SERVER";

export default {
  namespaced: true,
  state: {
    address: '',
    reports: [],
  },
  getters: {
    getAddress(state) {
      return state.address
    },
  },

  actions: {
    async fetchAddress({commit}) {
      const data = await this.$api.frserv.getAddress();
      commit(
        SET_ENTITY,
        { 
          module: module, 
          entity: "address", 
          value: data
        },
        { root: true }
      );
    },
   async fetchReportsList({ commit }) {
      const data = await this.$api.frserv.getReportsList();
      commit(
        SET_ENTITY,
        { 
          module: module, 
          entity: "reports", 
          value: data
        },
        { root: true }
      );
    },
  },
};